import { MultiSelect } from "primereact/multiselect";
import { useHomeContext } from "../contexts/HomeContext";
import moment from "moment";

interface IAssetsMultiSelectProps {
    period?: Date[];
    value: string[];
    assetsTypes?: string[];
    onChange: (value: string[]) => void;
    onChangeSelectedLabel?: (label: string) => void;
}

const AssetsMultiSelect = ({ period, value, assetsTypes = [], onChange, onChangeSelectedLabel }: IAssetsMultiSelectProps) => {
    const homeContext = useHomeContext();

    const toCurrency = (amount: number) => {
        return Intl.NumberFormat(
            "pt-BR", 
            { 
                style: "currency", 
                currency: "BRL"
            }
        )
        .format(amount)
    }
    const variables = homeContext.variableIncomeModel.map(v => ({ id: v.asset.id, name: `${v.asset.name} - ${toCurrency(v.asset.investedValue)}`, purchaseDate: v.asset.purchaseDate, type: v.mainType }));
    const fixeds = homeContext.fixedIncomeModel.map(f => ({ id: f.asset.id, name: `${f.asset.name} - ${toCurrency(f.asset.investedValue)}`, purchaseDate: f.asset.purchaseDate, type: f.mainType }));
    const cashflow = homeContext.cashflowModel.map(c => ({ id: c.asset.id, name: `${c.asset.name} - ${toCurrency(c.asset.investedValue)}`, purchaseDate: c.asset.purchaseDate, type: c.mainType }));
    const properties = homeContext.propertyModel.map(p => ({ id: p.asset.id, name: `${p.asset.name} - ${toCurrency(p.asset.investedValue)}`, purchaseDate: p.asset.purchaseDate, type: p.mainType }));
    const vehicles = homeContext.vehicleModel.map(v => ({ id: v.asset.id, name: `${v.asset.name} - ${toCurrency(v.asset.investedValue)}`, purchaseDate: v.asset.purchaseDate, type: v.mainType }));
    const assets = [...variables, ...fixeds, ...cashflow, ...properties, ...vehicles]
        .filter(a => period && a.purchaseDate ? moment(a.purchaseDate).isSameOrAfter(period[0]) && moment(a.purchaseDate).isSameOrBefore(period[1]) : true)
        .filter(a => assetsTypes.length === 0 || assetsTypes.includes(a.type));

    return (
        <MultiSelect 
            filter
            value={value} 
            onChange={(e) => {
                onChange(e.value);
                if (e.value.length === 0) {
                    onChangeSelectedLabel?.("");
                    return;
                }

                if (e.value.length > 2) {
                    onChangeSelectedLabel?.(`${e.value.length} selecionados`);
                    return;
                }

                onChangeSelectedLabel?.((e.value as string[]).map(subGroupIds => assets.filter(a => subGroupIds.includes(a.id)).map(a => a.name)).join(", "));
            }} 
            options={[
                {
                    label: "Renda fixa",
                    items: fixeds.filter(a => period && a.purchaseDate ? moment(a.purchaseDate).isSameOrAfter(period[0]) && moment(a.purchaseDate).isSameOrBefore(period[1]) : true)
                },
                {
                    label: "Renda variável",
                    items: variables.filter(a => period && a.purchaseDate ? moment(a.purchaseDate).isSameOrAfter(period[0]) && moment(a.purchaseDate).isSameOrBefore(period[1]) : true)
                },
                {
                    label: "Em caixa",
                    items: cashflow.filter(a => period && a.purchaseDate ? moment(a.purchaseDate).isSameOrAfter(period[0]) && moment(a.purchaseDate).isSameOrBefore(period[1]) : true)
                },
                {
                    label: "Imóveis",
                    items: properties.filter(a => period && a.purchaseDate ? moment(a.purchaseDate).isSameOrAfter(period[0]) && moment(a.purchaseDate).isSameOrBefore(period[1]) : true)
                },
                {
                    label: "Veículos",
                    items: vehicles.filter(a => period && a.purchaseDate ? moment(a.purchaseDate).isSameOrAfter(period[0]) && moment(a.purchaseDate).isSameOrBefore(period[1]) : true)
                }
            ].filter(o => o.items.length > 0)} 
            optionLabel="name" 
            optionValue="id"
            optionGroupLabel="label"
            optionGroupChildren="items"
            placeholder="Selecione os ativos" 
            maxSelectedLabels={2} 
            className="w-full" 
        />
    )
}

export default AssetsMultiSelect;